module.exports = __webpack_public_path__ + "static/media/card-American-Express-mobile-inactive.ed39c694.svg";